import React, { forwardRef } from 'react'

import { IconProps } from './types'

const PlaceholderCircle = forwardRef<SVGSVGElement, IconProps>(
  ({ size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx="8"
        cy="8"
        r="6"
        stroke={stroke || 'currentColor'}
        strokeLinecap="round"
        strokeDasharray="2 3"
      />
    </svg>
  ),
)
PlaceholderCircle.displayName = 'PlaceholderCircle'

export default PlaceholderCircle
